/* Flechas del carrusel "También podría gustarte" (2026-09-21).
 *
 * Sirve para dos bloques distintos: "También podría gustarte" de la ficha de
 * producto y "Los más vistos" del home. No comparten maquetado -- uno es un
 * <ul> flex y el otro son inline-block -- asi que el enganche es por
 * atributos y no por clase de maquetado:
 *
 *   [data-rel-carrusel]  el contenedor que tiene adentro las flechas y la tira
 *   [data-rel-pista]     el elemento que scrollea
 *
 * OJO CON EL CICLO DE VIDA -- el contenido de <product-recommendations> lo
 * trae el tema por fetch y REEMPLAZA todo el HTML de adentro, despues de
 * que carga la pagina. Por eso aca no se enganchan escuchas al nodo: se
 * delega en document (click) y se usa la fase de captura para el scroll,
 * que no burbujea. Asi sigue andando aunque el bloque se vuelva a dibujar.
 */
(function () {
  "use strict";

  function pista(flecha) {
    var caja = flecha.closest("[data-rel-carrusel]");
    return caja ? caja.querySelector("[data-rel-pista]") : null;
  }

  /* El ancho de una tarjeta. No se puede usar children[0]: el snippet de
     producto mete varios <link> de estilos como hermanos de la tarjeta, que
     miden 0. Se busca el primero que ocupe lugar. */
  function anchoTarjeta(p) {
    for (var i = 0; i < p.children.length; i++) {
      var w = p.children[i].getBoundingClientRect().width;
      if (w > 0) return w;
    }
    return 0;
  }

  function actualizar(p) {
    var caja = p.closest("[data-rel-carrusel]");
    if (!caja) return;
    var margen = 2; // px de tolerancia: el scroll no siempre cae exacto
    var fin = p.scrollWidth - p.clientWidth;
    caja.querySelectorAll(".rel-carrusel__flecha").forEach(function (f) {
      var dir = parseInt(f.getAttribute("data-rel-dir"), 10);
      var tope = dir < 0 ? p.scrollLeft <= margen : p.scrollLeft >= fin - margen;
      if (tope) { f.setAttribute("disabled", ""); } else { f.removeAttribute("disabled"); }
    });
  }

  document.addEventListener("click", function (e) {
    var f = e.target.closest ? e.target.closest(".rel-carrusel__flecha") : null;
    if (!f) return;
    e.preventDefault();
    var p = pista(f);
    if (!p) return;
    var dir = parseInt(f.getAttribute("data-rel-dir"), 10);
    // Avanza una pantalla menos una tarjeta asomando, para no perder de
    // vista donde estaba el visitante.
    var ancho = anchoTarjeta(p);
    var separacion = parseFloat(window.getComputedStyle(p).columnGap) || 20;
    var paso = ancho ? ancho + separacion : p.clientWidth;
    var saltos = Math.max(1, Math.floor(p.clientWidth / paso));
    p.scrollBy({ left: dir * paso * saltos, behavior: "smooth" });
  });

  document.addEventListener("scroll", function (e) {
    var t = e.target;
    if (t && t.hasAttribute && t.hasAttribute("data-rel-pista")) actualizar(t);
  }, true);

  function revisarTodas() {
    document.querySelectorAll("[data-rel-pista]").forEach(actualizar);
  }

  // Al cargar, cuando llega el HTML de las recomendaciones y al cambiar el
  // ancho (cambia cuantas tarjetas entran, o sea donde esta el final).
  document.addEventListener("DOMContentLoaded", revisarTodas);
  window.addEventListener("load", revisarTodas);
  window.addEventListener("resize", revisarTodas);
  new MutationObserver(revisarTodas).observe(document.documentElement, {
    childList: true, subtree: true,
  });
})();
